import React from "react";
import WithSnowFlakes from "../../components/LandingPage/WithSnowFlakes";

const ReferTerms = () => {
  return (
    <WithSnowFlakes>
      <div className="flex flex-col w-full items-center px-4 py-20 overflow-scroll ">
        <div className="w-full max-w-[1200px] terms">
          <div className="text-snow-white font-bold text-5xl text-center font-catamaran">
            Refer A Friend
          </div>
          <div className="mt-20 text-snow-white font-light text-2xl text-left font-noto">
            <p>
              If SnowScape helps you get your job done, help us spread the word!
              Refer a friend using your unique referral code and you both win!
            </p>
            <h2 className="font-bold my-2">Terms</h2>
            <ol>
              <li>Both free and paid accounts can refer new users</li>
              <li>
                You will only receive a bonus for the referral if the new signup
                is for a paid plan and they remain a customer for 1 month.
              </li>
              <li>
                The bonus will be in the form of credit to your account which
                can be used towards your company's subscription. It cannot be
                redeemed for cash or any other form of reimbursement.
              </li>
              <li>
                SnowScape reserves the right to withhold or cancel the bonus for
                any reason.
              </li>
              <li>
                You will receive the credit to your account within 30 days after
                the new customer pays their monthly invoice.
              </li>
              <li>There is no limit to how many companies you can refer.</li>
            </ol>
          </div>
        </div>
      </div>
    </WithSnowFlakes>
  );
};

export default ReferTerms;
